package com.trevorwiebe.timesheet.invoicing.data.dto

import com.trevorwiebe.timesheet.invoicing.domain.model.Payment
import com.trevorwiebe.timesheet.invoicing.domain.model.PaymentAllocation
import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable

@Serializable
data class PaymentDto(
    val customerId: String = "",
    val customerName: String = "",
    val date: String = "",
    val amount: Int = 0,
    val allocations: List<PaymentAllocationDto> = emptyList(),
    val notes: String = "",
)

@Serializable
data class PaymentAllocationDto(
    val invoiceId: String = "",
    val invoiceNumber: Int = 0,
    val amount: Int = 0,
)

fun PaymentDto.toPayment(id: String): Payment = Payment(
    id = id,
    customerId = customerId,
    customerName = customerName,
    date = LocalDate.parse(date),
    amount = amount,
    allocations = allocations.map { PaymentAllocation(it.invoiceId, it.invoiceNumber, it.amount) },
    notes = notes,
)

fun Payment.toPaymentDto(): PaymentDto = PaymentDto(
    customerId = customerId,
    customerName = customerName,
    date = date.toString(),
    amount = amount,
    allocations = allocations.map { PaymentAllocationDto(it.invoiceId, it.invoiceNumber, it.amount) },
    notes = notes,
)
